
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/second-opinion-thoracic-surgeon-india",
      function () {
        return require("private-next-pages/ru/second-opinion-thoracic-surgeon-india.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/second-opinion-thoracic-surgeon-india"])
      });
    }
  